import { Link, useRouteError } from 'react-router';
import { buttonClass } from '@/ui/button';

/** Shown when a page throws or a route doesn't exist. */
export function RouteError() {
  const error = useRouteError();
  const notFound =
    typeof error === 'object' && error !== null && 'status' in error && error.status === 404;
  if (!notFound) console.error(error);
  return (
    <main
      style={{ maxWidth: 640, margin: '0 auto', padding: '64px 24px', display: 'grid', gap: 16 }}
    >
      <h1 style={{ fontFamily: 'var(--kyc-font-display)' }}>
        {notFound ? 'Page not found' : 'Something went wrong'}
      </h1>
      <p style={{ color: 'var(--kyc-text-secondary)' }}>
        {notFound
          ? "This page doesn't exist."
          : 'An unexpected error stopped this page. Your library is safe: it is stored in this browser.'}
      </p>
      <Link to="/" className={buttonClass('primary')} style={{ justifySelf: 'start' }}>
        Back to library
      </Link>
    </main>
  );
}
